import Web3 from 'web3/dist/web3.min.js'

async function deposit(address_, value_) {
  const accounts = await ethereum.request({ method: 'eth_accounts' });
  // const contract = new web3.eth.Contract(replicatorABI, address_)
  // contract.methods.transfer('some params')
  //  .send({
  //          from: accounts[0],
  //          value: value_
  //       }).then(receipt=> {consol.log(receipt)});


  value_ = web3.utils.toWei(String(value_), 'ether');
  value_ = web3.utils.numberToHex(value_)

  var _hex_gasPrice = web3.utils.toWei(String(2.5), 'gwei');
  _hex_gasPrice = web3.utils.numberToHex(_hex_gasPrice)

  var _hex_Gas = web3.utils.toWei(String(1000000), 'wei');
  _hex_Gas = web3.utils.numberToHex(_hex_Gas)

  console.log(accounts[0], value_);
  // window.ethereum
  try {
    const transactionHash = await ethereum.request({
      method: 'eth_sendTransaction',
      params: [
        {
          to: address_,
          from: accounts[0],
          value: String(value_),
          gasPrice: _hex_gasPrice,
          gas: _hex_Gas,
        },
      ],
    });
    // Handle the result
    console.log(transactionHash);
  } catch (error) {
    console.error(error);
  }

}

async function buy(address_, value_) {
  const accounts = await ethereum.request({ method: 'eth_accounts' });
  const contract = await new web3.eth.Contract(replicatorABI, address_)

  // FIX: the value must be changed to decimal.
  value_ = web3.utils.toWei(String(0.02), 'ether');
  value_ = web3.utils.numberToHex(value_)
  let gas_ = web3.utils.toWei(String(2), 'gwei');

  console.log("0: ", contract.address, value_);
  console.log("1: ", address_, value_);


  // data: contract.methods.transfer(toAddress, _hex_value).encodeABI()
  // await contract.methods.buy().send({from: accounts[0], to: address_, value: value_, gasPrice: gas_, gas: 6000393218})

  try {
    const transactionHash = await ethereum.request({
      method: 'eth_sendTransaction',
      params: [
        {
          to: address_,
          from: accounts[0],
          value: String(value_),
          data: contract.methods.buy().encodeABI()
        },
      ],
    });
    // Handle the result
    console.log(transactionHash);
  } catch (error) {
    console.error(error);
  }

  // var id = await contract.methods.nftIndex().call()
  // console.log(await nft.methods.ownerOf(id).call())
  // let total = await nft.methods.grantMinterRole(address_).send({from: accounts[0]})

  // // window.ethereum
  // try {
  //   contract.methods.buy().call({from: accounts[0], value: value_, gasPrice: gas_, gas: 67393218})
  // } catch (error) {
  //   console.error(error);
  // }

}

async function poke () {
  let total = await nft.methods.totalSupply().call()
  console.log("total: ", total)
  let images = []
  for(let i=1; i<=1; i++){
    let address = await nft.methods.minterOf(i).call();
    console.log('minter: ', address);
    deposit(address, '133238529999900')

    // console.log(web3.eth.accounts[0]);

    // let gasPrice = web3.utils.toWei(String(240), 'gwei');
    // let tokenURI = await nft.methods.tokenURI(i).call({from: SEND_ADDR, gasPrice: gasPrice, gas: 17393218});
    // // console.log(JSON.parse(Buffer.from(tokenURI.replace(/^data:\w+\/\w+;base64,/, ''), "base64")))
    // let image = JSON.parse(Buffer.from(tokenURI.replace(/^data:\w+\/\w+;base64,/, ''), "base64"));
    // console.log(image)
    // images.push(image)
    // // let test = image.replace(/^data:image+\/svg+\+xml;base64,/, '');
    // // test = Buffer.from(test, 'base64');
  }
  return images
}

async function getBalances () {
  let total = await nft.methods.totalSupply().call()
  console.log("total: ", total)
  let balances = []
  for(let i=1; i<=total; i++){
    let address = await nft.methods.minterOf(i).call();
    console.log('minter: ', address);
    let balance = await web3.eth.getBalance(address)
    console.log(balance)
    balances.push(balance)
  }
  return balances
}

let currentWeb3;

async function loadWeb3() {
  if (window.ethereum) {
      window.web3 = new Web3(window.ethereum);
      window.ethereum.enable();
  }

  // window.ethereum
  // const accounts = await ethereum.request({ method: 'eth_accounts' });
  // console.log("koko: ", accounts)

  // let ethereum = window.ethereum;
  //
  // let web3 = window.web3;
  // if (typeof ethereum !== 'undefined') {
  //  await ethereum.enable();
  //  web3 = new Web3(ethereum);
  // } else if (typeof web3 !== 'undefined') {
  //  web3 = new Web3(web3.currentProvider);
  // } else {
  //  web3 = new Web3(new Web3.providers.HttpProvider(process.env.WEB3_PROVIDER));
  // }
}

async function load() {
    await loadWeb3();
    // updateStatus('Ready!');
    if (window.ethereum){
      return true
    }else{
      return false
    }
}

function updateStatus(status) {
    const statusEl = document.getElementById('status');
    statusEl.innerHTML = status;
    console.log(status);
}

async function getChildren (address_) {
  const parent = new web3.eth.Contract(replicatorABI, address_)
  let parent_obj = {"name": address_}

  let n_children = await parent.methods.numChildren().call()
  console.log('minter: ', address_);
  console.log("children: ", n_children)

  let children = []
  for(let i=1; i<=n_children; i++){
    let address = await parent.methods.children(i).call()
    console.log("child: ", address)
    const child = new web3.eth.Contract(replicatorABI, address)
    // var child_obj = {"name": address};
    let tmp = await getChildren(address)
    // if (tmp.length > 0){
      // child_obj.children = tmp
    // }
    children.push(tmp)
  }
  if (children.length > 0){
    parent_obj.children = children
  }
  // console.log(parent_obj)
  return parent_obj
}

async function getTokenURI(index_){
  let gasPrice = web3.utils.toWei(String(240), 'gwei');
  let tokenURI = await nft.methods.tokenURI(index_).call({from: SEND_ADDR, gasPrice: gasPrice, gas: 17393218});
  // console.log(JSON.parse(Buffer.from(tokenURI.replace(/^data:\w+\/\w+;base64,/, ''), "base64")))
  let image = JSON.parse(Buffer.from(tokenURI.replace(/^data:\w+\/\w+;base64,/, ''), "base64")).image;
  console.log(image)
}

async function makeTree () {
  let total = await nft.methods.totalSupply().call()
  console.log("total: ", total)
  let images = []
  let address = await nft.methods.minterOf(1).call();
  let treeTest = await getChildren(ORIGIN_ADDR)
  console.log(treeTest);
  console.log(JSON.stringify(treeTest))
    // console.log(web3.eth.accounts[0]);

    // let gasPrice = web3.utils.toWei(String(240), 'gwei');
    // let tokenURI = await nft.methods.tokenURI(i).call({from: SEND_ADDR, gasPrice: gasPrice, gas: 17393218});
    // // console.log(JSON.parse(Buffer.from(tokenURI.replace(/^data:\w+\/\w+;base64,/, ''), "base64")))
    // let image = JSON.parse(Buffer.from(tokenURI.replace(/^data:\w+\/\w+;base64,/, ''), "base64"));
    // console.log(image)
    // images.push(image)
    // // let test = image.replace(/^data:image+\/svg+\+xml;base64,/, '');
    // // test = Buffer.from(test, 'base64');
  return treeTest
}


const tokenABI = [ { "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "approved", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "operator", "type": "address" }, { "indexed": false, "internalType": "bool", "name": "approved", "type": "bool" } ], "name": "ApprovalForAll", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "indexed": true, "internalType": "bytes32", "name": "previousAdminRole", "type": "bytes32" }, { "indexed": true, "internalType": "bytes32", "name": "newAdminRole", "type": "bytes32" } ], "name": "RoleAdminChanged", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "indexed": true, "internalType": "address", "name": "account", "type": "address" }, { "indexed": true, "internalType": "address", "name": "sender", "type": "address" } ], "name": "RoleGranted", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "indexed": true, "internalType": "address", "name": "account", "type": "address" }, { "indexed": true, "internalType": "address", "name": "sender", "type": "address" } ], "name": "RoleRevoked", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "Transfer", "type": "event" }, { "inputs": [], "name": "DEFAULT_ADMIN_ROLE", "outputs": [ { "internalType": "bytes32", "name": "", "type": "bytes32" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "_genomes", "outputs": [ { "internalType": "int8", "name": "", "type": "int8" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "approve", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "owner", "type": "address" } ], "name": "balanceOf", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "int8[9]", "name": "_genome", "type": "int8[9]" } ], "name": "createItem", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "getApproved", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "_tokenId", "type": "uint256" } ], "name": "getFeeBps", "outputs": [ { "internalType": "uint256[]", "name": "", "type": "uint256[]" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "_tokenId", "type": "uint256" } ], "name": "getFeeRecipients", "outputs": [ { "internalType": "address payable[]", "name": "", "type": "address[]" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "bytes32", "name": "role", "type": "bytes32" } ], "name": "getRoleAdmin", "outputs": [ { "internalType": "bytes32", "name": "", "type": "bytes32" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "int8[9]", "name": "_genome", "type": "int8[9]" } ], "name": "getSVG", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "pure", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "_address", "type": "address" } ], "name": "grantMinterRole", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "internalType": "address", "name": "account", "type": "address" } ], "name": "grantRole", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "internalType": "address", "name": "account", "type": "address" } ], "name": "hasRole", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "operator", "type": "address" } ], "name": "isApprovedForAll", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "index", "type": "uint256" } ], "name": "minterOf", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "name", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "ownerOf", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "internalType": "address", "name": "account", "type": "address" } ], "name": "renounceRole", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "bytes32", "name": "role", "type": "bytes32" }, { "internalType": "address", "name": "account", "type": "address" } ], "name": "revokeRole", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "bytes", "name": "_data", "type": "bytes" } ], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "operator", "type": "address" }, { "internalType": "bool", "name": "approved", "type": "bool" } ], "name": "setApprovalForAll", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "_tokenId", "type": "uint256" }, { "internalType": "address payable[]", "name": "_royaltyAddress", "type": "address[]" }, { "internalType": "uint256[]", "name": "_royalty", "type": "uint256[]" } ], "name": "setCustomRoyality", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "bytes4", "name": "_interfaceId", "type": "bytes4" } ], "name": "supportsInterface", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "tokenURI", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" } ], "name": "transferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" } ]

const replicatorABI = [ { "inputs": [ { "internalType": "contract Duplicator", "name": "_duplicator", "type": "address" }, { "internalType": "address", "name": "_owner", "type": "address" }, { "internalType": "address", "name": "_nft", "type": "address" }, { "internalType": "address", "name": "_parent", "type": "address" }, { "internalType": "int8[9]", "name": "_genome", "type": "int8[9]" } ], "stateMutability": "nonpayable", "type": "constructor" }, { "stateMutability": "payable", "type": "fallback" }, { "inputs": [], "name": "buy", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "children", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "createNFT", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "feed", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "genome", "outputs": [ { "internalType": "int8", "name": "", "type": "int8" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "getGenome", "outputs": [ { "internalType": "int8[9]", "name": "", "type": "int8[9]" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "nft", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "nftIndex", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "numChildren", "outputs": [ { "internalType": "uint256", "name": "_value", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "parent", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "poke", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "replicate", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "int8[9]", "name": "_genome", "type": "int8[9]" } ], "name": "setGenome", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "_newAddress", "type": "address" } ], "name": "setNftAddress", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "widthdrawAll", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "stateMutability": "payable", "type": "receive" } ]

const ABI_NFT_PATH = '../../../contracts/NFT/artifacts/NFT.json'
// let NFT_ADDR = '0x74A7273FdD034b608F732994f75b3ba28fCB2291' // for whitehouse deploy rinkeby
// let ORIGIN_ADDR = '0x24eab09796274D47A720599021faC87CA86f4D36' //for whitehouse deploy rinkeby

let NFT_ADDR = '0xDBcF56F70407248eBFAd80B7E21828afa08b37A6' // for local test
let ORIGIN_ADDR = '0x2115aeFf7a7DcCfc1f28e88F38Cbb973a7D551e0' //for local test

let SEND_ADDR = '0x69e5e89bc6Cc77B68A4d607eB52dD3032c4E72BD';

// for deploy
const END_POINT = 'https://rinkeby.infura.io/v3/3e9429f88dc64ff4b6d7c477d19a0d27'
var web3 = new Web3(new Web3.providers.HttpProvider(END_POINT))

// // for local test
// const END_POINT = 'ws://127.0.0.1:8545'
// var web3 = new Web3(END_POINT)

const nft = new web3.eth.Contract(tokenABI, NFT_ADDR)


export default {
  load,
  deposit,
  poke,
  makeTree,
  buy
};



// WEBPACK FOOTER //
// ./src/web3_util.js